
import { useNavigate } from 'react-router-dom';

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#2A4B7C] to-[#00C897] flex items-center justify-center p-4">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-20 w-20 h-20 bg-white/10 rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-16 h-16 bg-white/15 rounded-full animate-bounce"></div>
        <div className="absolute bottom-40 left-20 w-12 h-12 bg-white/20 rounded-full animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-24 h-24 bg-white/10 rounded-full animate-bounce"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        {/* Warning Icon */}
        <div className="mb-8">
          <div className="w-32 h-32 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
            <i className="ri-shield-cross-line text-6xl text-white"></i>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12">
          <div className="mb-8">
            <h1 className="text-4xl md:text-5xl font-bold text-[#333333] mb-4">
              TRUY CẬP BỊ TỪ CHỐI
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-[#2A4B7C] to-[#00C897] mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 leading-relaxed">
              Bạn không có quyền truy cập vào khu vực này. Vui lòng đăng nhập với tài khoản có quyền quản trị.
            </p>
          </div>

          {/* Warning Details */}
          <div className="bg-gradient-to-r from-[#2A4B7C]/10 to-[#00C897]/10 rounded-xl p-6 mb-8 border border-[#2A4B7C]/20">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-gradient-to-br from-[#2A4B7C] to-[#00C897] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-white text-xl"></i>
              </div>
              <div className="text-left">
                <h3 className="text-lg font-bold text-[#333333] mb-2">Thông tin bảo mật</h3>
                <ul className="text-gray-600 space-y-2 text-sm">
                  <li className="flex items-center gap-2">
                    <i className="ri-check-line text-[#00C897]"></i>
                    Khu vực này chỉ dành cho quản trị viên
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-check-line text-[#00C897]"></i>
                    Mọi hoạt động truy cập đều được ghi lại
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-check-line text-[#00C897]"></i>
                    Vui lòng liên hệ admin nếu cần hỗ trợ
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/login')}
              className="bg-gradient-to-r from-[#2A4B7C] to-[#00C897] hover:from-[#2A4B7C]/90 hover:to-[#00C897]/90 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-login-box-line mr-2"></i>
              Đăng nhập Admin
            </button>
            <button
              onClick={() => navigate('/')}
              className="border-2 border-[#2A4B7C] text-[#2A4B7C] hover:bg-[#2A4B7C] hover:text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-line mr-2"></i>
              Về trang chủ
            </button>
          </div>

          {/* Contact Info */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-gray-500 text-sm mb-4">Cần hỗ trợ? Liên hệ với chúng tôi:</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center text-sm">
              <a href="mailto:admin@stackway.tech" className="text-[#2A4B7C] hover:text-[#00C897] transition-colors cursor-pointer flex items-center gap-2 justify-center">
                <i className="ri-mail-line"></i>
                admin@stackway.tech
              </a>
              <a href="tel:+84xxxxxxxxx" className="text-[#2A4B7C] hover:text-[#00C897] transition-colors cursor-pointer flex items-center gap-2 justify-center">
                <i className="ri-phone-line"></i>
                +84 xxx xxx xxx
              </a>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-white/80 text-sm">
            &copy; 2024 StackWay. Hệ thống được bảo vệ bởi các biện pháp bảo mật tiên tiến.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
